module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/MoneymanGirl-e02d6844f6a7dbe7cd8aad516b173f34.png";